import * as React from 'react';

const SvgLinkedinStatusUpdate = props => {
  const { size, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <g>
        <rect x={2} y={8.5} width={5} height={14} rx={0.5} />
        <path d="M4.48 6.5A2.5 2.5 0 102 4a2.49 2.49 0 002.48 2.5zM18.5 22.5h3a.5.5 0 00.5-.5v-8.4C22 9.83 19.87 8 16.89 8a4.22 4.22 0 00-3.18 1.28.39.39 0 01-.45.09A.4.4 0 0113 9a.5.5 0 00-.5-.5h-3A.5.5 0 009 9v13a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-7.5a2.5 2.5 0 015 0V22a.5.5 0 00.5.5z" />
      </g>
    </svg>
  );
};

export default SvgLinkedinStatusUpdate;
